import {Component, inject, Signal, ViewEncapsulation} from '@angular/core';
import {CartStatuses} from 'src/app/home/config/cart-status-data.const';
import {ECalculusStateFilter} from 'src/app/home/config/state-filter.enum';
import {ProcessOverviewStore} from '../service/process-overview.store';
import {MatLabel} from '@angular/material/form-field';
import {ICart, IClient, IInvoice, IProcessState} from '../service/state.interface';
import {ICartStatus, ICartStatusOnHold, ICartStatusUncollectible} from '../../../config/cart-status-data.interface';
import {CalculusStore} from "../../../../Services/calculus.store";

type TColorLabel = 'Rot' | 'Orange' | 'Grün';

@Component({
  selector: 'kpi4me-bread-crumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [MatLabel]
})
export class BreadCrumbComponent {
  private _processOverviewService: ProcessOverviewStore = inject(ProcessOverviewStore);
  calculusStore: CalculusStore = inject(CalculusStore);

  selectedClient: Signal<IClient> = this._processOverviewService.selectedClient;
  selectedCart: Signal<ICart> = this._processOverviewService.selectedCart;
  selectedInvoice: Signal<IInvoice> = this._processOverviewService.selectedInvoice;
  selectedProcess: Signal<IProcessState> = this._processOverviewService.selectedProcess;

  CartStatuses: Map<ECalculusStateFilter, ICartStatus | ICartStatusOnHold | ICartStatusUncollectible> = CartStatuses;

  stateFilterToLabelMap: Map<ECalculusStateFilter, TColorLabel> = new Map<ECalculusStateFilter, TColorLabel>([
    [ECalculusStateFilter.kpiConnectError, 'Rot'],
    [ECalculusStateFilter.ETLnMappingError, 'Rot'],
    [ECalculusStateFilter.checkError, 'Rot'],
    [ECalculusStateFilter.createInvoiceError, 'Rot'],
    [ECalculusStateFilter.arrangeInvoiceError, 'Rot'],
    [ECalculusStateFilter.monitorPaymentError, 'Rot'],
    [ECalculusStateFilter.totalError, 'Rot'],
    [ECalculusStateFilter.kpiConnectWarning, 'Orange'],
    [ECalculusStateFilter.ETLnMappingWarning, 'Orange'],
    [ECalculusStateFilter.checkWarning, 'Orange'],
    [ECalculusStateFilter.createInvoiceWarning, 'Orange'],
    [ECalculusStateFilter.arrangeInvoiceWarning, 'Orange'],
    [ECalculusStateFilter.monitorPaymentWarning, 'Orange'],
    [ECalculusStateFilter.totalWarning, 'Orange'],
    [ECalculusStateFilter.kpiConnectOk, 'Grün'],
    [ECalculusStateFilter.ETLnMappingOk, 'Grün'],
    [ECalculusStateFilter.checkOk, 'Grün'],
    [ECalculusStateFilter.createInvoiceOk, 'Grün'],
    [ECalculusStateFilter.arrangeInvoiceOk, 'Grün'],
    [ECalculusStateFilter.monitorPaymentOk, 'Grün'],
    [ECalculusStateFilter.totalOk, 'Grün'],
  ])

  onCategoryClicked(category: ECalculusStateFilter): void {
    this._processOverviewService.selectedProcessCategory$.next(category);
  }

  onStateClicked(state: ECalculusStateFilter): void {
    this._processOverviewService.selectedProcessState$.next({
      category: this.selectedProcess().category,
      state
    });
  }

  onCartFilterObjClicked(): void {
    this._processOverviewService.selectedCart$.next(null);
  }

  showHelpForBreadcrumb(): void {
    this.calculusStore.helpRoute$.next('prozessübersicht.html#breadcrumb');
  }
}
